import { InjectionToken } from '@angular/core';

export const LOCATION_TOKEN = new InjectionToken<Location>(
  'Window location object'
);
export const UPDATE_SERVICE_AUTO_DELAY = new InjectionToken<number>(
  'How long to wait before forcing an update'
);
